import React, { Component } from 'react'
import Lottie from 'react-lottie'

class LottieAnimation extends Component {


    render(){

        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: this.props.data,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };

        return(
            <div className = { this.props.className }>
                <div className = 'lottie_wrapper'> 
                    <Lottie options={defaultOptions} />
                </div>
            </div>
        )
    }
}

export default LottieAnimation